import { AddVoucherErrorCodeV1 } from '@vista-digital/ocapi-client';
import { CommonErrorCodes } from '../../../../../types/errors/common-error-codes';
import { OrderDomainSpecificErrorCode } from '../../../errors/order-domain-error';
export const mapAddVoucherErrorCodeToDomainErrorCode = (errorCode) => {
    switch (errorCode) {
        case AddVoucherErrorCodeV1.VoucherCredentialsInvalid:
            return OrderDomainSpecificErrorCode.VoucherCredentialsInvalid;
        case AddVoucherErrorCodeV1.VoucherAlreadyAdded:
            return OrderDomainSpecificErrorCode.VoucherAlreadyAdded;
        case AddVoucherErrorCodeV1.VoucherInvalidated:
            return OrderDomainSpecificErrorCode.VoucherInvalidated;
        case AddVoucherErrorCodeV1.NoRedemptionsLeft:
            return OrderDomainSpecificErrorCode.NoVoucherRedemptionsLeft;
        case AddVoucherErrorCodeV1.VoucherExpired:
            return OrderDomainSpecificErrorCode.VoucherExpired;
        case AddVoucherErrorCodeV1.VoucherInvalidForOrder:
            return OrderDomainSpecificErrorCode.VoucherInvalidForOrder;
        default:
            return CommonErrorCodes.UnknownError;
    }
};
